module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [(_vm.isCaminhoParana) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "parana-way-box"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "second-col-box margin-b20"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "height-72 padding-12"
  }, [_c('button', {
    staticClass: "inline bold btn-charge btn-charge-minus",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.calculateManParanaWay(_vm.rechargeMan - 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-minus"
  })]), _vm._v(" "), _c('input', {
    staticClass: "inline form-control bold",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm._f("cents")(_vm.rechargeValueMan)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "inline bold btn-charge btn-charge-plus",
    attrs: {
      "type": "button",
      "name": "button",
      "autofocus": ""
    },
    on: {
      "click": function($event) {
        return _vm.calculateManParanaWay(_vm.rechargeMan + 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row-button border-radius-bottom"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextParana('man')
      }
    }
  }, [_vm._v("\n                Quero este plano!\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "third-col-box margin-b20"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "height-72 padding-12"
  }, [_c('button', {
    staticClass: "inline bold btn-charge btn-charge-minus",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.calculateAutParanaWay(_vm.rechargeAut - 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-minus"
  })]), _vm._v(" "), _c('input', {
    staticClass: "inline form-control bold",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm._f("cents")(_vm.rechargeValueAut)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "inline bold btn-charge btn-charge-plus",
    attrs: {
      "type": "button",
      "name": "button",
      "autofocus": ""
    },
    on: {
      "click": function($event) {
        return _vm.calculateAutParanaWay(_vm.rechargeAut + 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row-button border-radius-bottom"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextParana('aut')
      }
    }
  }, [_vm._v("\n                Quero este plano!\n              ")])])])])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-4 box-plan",
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.recVp === 'N') ? _c('div', {
    staticClass: "alert-warning",
    staticStyle: {
      "background-color": "#fcdec1",
      "margin-bottom": "25px",
      "padding": "20px",
      "margin": "23px",
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" Este plano não recebe Vale-pedágio Eletrônico.\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "label-semibold"
  }, [_vm._v("Plano Escolhido:")]), _vm._v(" "), _c('p', {
    staticClass: "title-plan"
  }, [_vm._v(_vm._s(_vm.plan && _vm.plan.name))]), _vm._v(" "), _c('img', {
    staticClass: "choosed-plan-cart",
    attrs: {
      "src": require("../../../assets/img/img-selected-plan.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.planId == _vm.CO.PLAN_EMBARCADOR_PJ) ? _c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10)]) : (_vm.planId == _vm.CO.PLAN_MOVE_PAGUE) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "second-col-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Valores do plano")]), _vm._v(" "), _c('div', {
    staticClass: "line-table two-lines"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.newAdhesionTax > 0) ? _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n            ")]) : _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "line-table two-lines"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.guaranteeTax)))])])])])]) : (_vm.planId == 2 || _vm.planId == 3) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "second-col-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Informações")]), _vm._v(" "), _c('div', {
    staticClass: "row row-fix"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-t20"
  }, [_c('div', {
    staticClass: "margin-l-10 form-group text-left",
    class: {
      'has-error': _vm.errors.has('taxIdNumber')
    }
  }, [_c('label', [_vm._v("Digite o CPF ou CNPJ do seu RNTRC:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxIdNumber),
      expression: "taxIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpfCnpj|accountExists:cpf'),
      expression: "'required|cpfCnpj|accountExists:cpf'"
    }, {
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }],
    staticClass: "form-control small rntrc-input",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
      "id": "taxIdNumber",
      "name": "taxIdNumber",
      "data-vv-validate-on": "blur",
      "placeholder": "",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.taxIdNumber)
    },
    on: {
      "input": _vm.cleanErrors,
      "change": function($event) {
        _vm.taxIdNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("taxIdNumber")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-fix"
  }, [_c('div', {
    staticClass: "col-xs-12 rntrc-adhesion-row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.newAdhesionTax)))])])])]), _vm._v(" "), _vm._m(15)])]) : (_vm.planId == 51 || _vm.planId == 52) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "second-col-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Valores do plano")]), _vm._v(" "), _c('div', {
    staticClass: "line-table"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.newAdhesionTax > 0) ? _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n            ")]) : _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-table-striped"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "inline bold btn-charge btn-charge-minus",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.calculate(_vm.recharge - 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-minus"
  })]), _vm._v(" "), _c('input', {
    staticClass: "inline form-control bold",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm._f("cents")(_vm.rechargeValue)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "inline bold btn-charge btn-charge-plus",
    attrs: {
      "type": "button",
      "name": "button",
      "autofocus": ""
    },
    on: {
      "click": function($event) {
        return _vm.calculate(_vm.recharge + 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })])])]), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _vm._m(19)]) : _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "second-col-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Valores do plano")]), _vm._v(" "), (_vm.sameTax) ? _c('div', {
    staticClass: "line-table"
  }, [_vm._m(20), _vm._v(" "), (!_vm.checkPromoSenff) ? _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.newAdhesionTax > 0 && !_vm.promoId) ? _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n            ")]) : _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])]) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "line-table"
  }, [_vm._m(21), _vm._v(" "), (!_vm.checkPromoSenff) ? _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.newAdhesionTax > 0 && !_vm.promoId) ? _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n            ")]) : _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])]) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "line-table"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.newVehicleTax > 0) ? _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newVehicleTax)) + "\n            ")]) : _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-table-striped"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-plan"
  }, [_vm._v("Carga inicial:")]), _vm._v(" "), _c('p', {
    staticClass: "label-first-charge margin-b0"
  }, [_vm._v("\n              (É necessário no ato da\n              " + _vm._s(_vm.newSalesType == "MIGRATIONPLAN" ? "migração" : "adesão") + "\n              realizar uma carga inicial)\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "inline bold btn-charge btn-charge-minus",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.promoId
          ?
          _vm.firstValueRecharge(_vm.recharge - 1) :
          _vm.calculate(_vm.recharge - 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-minus"
  })]), _vm._v(" "), _c('input', {
    staticClass: "inline form-control bold",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm._f("cents")(_vm.rechargeValue)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "inline bold btn-charge btn-charge-plus",
    attrs: {
      "type": "button",
      "name": "button",
      "autofocus": ""
    },
    on: {
      "click": function($event) {
        _vm.promoId
          ?
          _vm.firstValueRecharge(_vm.recharge + 1) :
          _vm.calculate(_vm.recharge + 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "line-table"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.taxRecharge)))])])]), _vm._v(" "), _c('div', {
    staticClass: "line-table-striped"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 coupon-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coupon),
      expression: "coupon"
    }],
    staticClass: "form-control input-coupon",
    attrs: {
      "type": "text",
      "name": "coupon",
      "placeholder": "Digite o código",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.coupon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coupon = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.planId == 21) ? _c('div', [_c('div', {
    staticClass: "line-table",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.planId == 21) ? _c('div', {
    staticClass: "label-plan"
  }, [_vm._v("\n                Quero ser avisado quando meu saldo atingir o valor de:\n                " + _vm._s(_vm.limiteFormatado()) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "fleet-switch"
  }, [_c('div', {
    staticClass: "onoffswitch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.lcFlag),
      expression: "contract.lcFlag"
    }],
    staticClass: "onoffswitch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "round-switch"
    },
    domProps: {
      "checked": Array.isArray(_vm.contract.lcFlag) ? _vm._i(_vm.contract.lcFlag, null) > -1 : (_vm.contract.lcFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contract.lcFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contract, "lcFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contract, "lcFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contract, "lcFlag", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(25)])])])])]) : (_vm.planId == 22 || _vm.planId == 62 || _vm.planId == 64) ? _c('div', [_c('div', {
    staticClass: "line-table-striped-white"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(26)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 first-col-box"
  }, [_c('div', {
    staticClass: "height-112 border-radius-top"
  }, [_c('p', {
    staticClass: "margin-10"
  }, [_c('i', {
    staticClass: "icon-plans icon-plans-table"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "height-72"
  }, [_c('p', {
    staticClass: "bold no-margin padding-23"
  }, [_vm._v("Como Funciona?")])]), _vm._v(" "), _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin padding-18"
  }, [_vm._v("Adesão por Veículo")])]), _vm._v(" "), _c('div', {
    staticClass: "height-72"
  }, [_c('p', {
    staticClass: "bold no-margin padding-t6"
  }, [_vm._v("Carga Inicial")]), _vm._v(" "), _c('small', [_vm._v("(É necessário na adesão realizar uma carga inicial)")])]), _vm._v(" "), _c('div', {
    staticClass: "height-82 striped-line"
  }, [_c('p', {
    staticClass: "bold no-margin padding-12"
  }, [_vm._v("Formas de Pagamento")])]), _vm._v(" "), _c('div', {
    staticClass: "height-72-exp border-radius-bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-112 border-radius-top"
  }, [_c('h3', {
    staticClass: "title plan upper no-margin margin-b10"
  }, [_vm._v("\n                Pré-pago Manual\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                Excelente para você que quer ter controle total dos seus\n                gastos e tem tempo para planejar as suas recargas.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72 padding-t16"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                Sempre que precisar realizar uma nova recarga, você deverá\n                acessar a área do cliente (Meus Planos) e recarregar.\n                Disponível no app e no site.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("Grátis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-12 center-flex-vertical"
  }, [_c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-112 border-radius-top"
  }, [_c('h3', {
    staticClass: "title plan upper no-margin margin-b10"
  }, [_vm._v("\n                Pré-pago Automático\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                Perfeito para você que gosta de comodidade e não quer se\n                preocupar com recargas ou saldo insuficiente.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72 height-72-big padding-18"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                Você define o valor da recarga e sempre que o seu saldo\n                atingir 40%, nós realizamos uma nova recarga para você.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("Grátis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-20 center-flex-vertical"
  }, [_c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "second-col-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Valores do plano")]), _vm._v(" "), _c('div', {
    staticClass: "shipper-description"
  }, [_vm._v("\n          Este plano tem adesão gratuita, aproveite!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "shipper-tax-box"
  }, [_vm._v("\n          Taxa de adesão:\n          "), _c('h3', {
    staticClass: "shipper-tax-value"
  }, [_vm._v("Grátis")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          ¹ ² As condições promocionais estão sujeitas às regras de cada\n          campanha vigente.\n          "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n            Consulte o regulamento")]), _vm._v(".\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n              ¹ ² As condições promocionais estão sujeitas às regras de cada\n              campanha vigente.\n              "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n                Consulte o regulamento")]), _vm._v(".\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9"
  }, [_c('p', {
    staticClass: "label-plan label-plan-garantee"
  }, [_vm._v("\n              Saldo Caução por veículo:\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin sub"
  }, [_vm._v("\n              Valor debitado uma única vez no ato da adesão.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "sub margin-10"
  }, [_vm._v("\n              * Valor devolvido no cancelamento do plano.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-fix"
  }, [_c('div', {
    staticClass: "col-xs-12 rntrc-bind-value-row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Vinculação RNTRC:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('h4', {
    staticClass: "label-plan-rntrc-value"
  }, [_vm._v("GRÁTIS*\n              ")]), _vm._v(" "), _c('small', [_vm._v("* Conforme Deliberação Nº 400 da ANTT.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-plan"
  }, [_vm._v("Carga inicial:")]), _vm._v(" "), _c('p', {
    staticClass: "label-first-charge"
  }, [_vm._v("\n              (É necessário no ato da adesão realizar uma carga inicial)\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-table"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Taxa de Recarga"), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          ¹ ² As condições promocionais estão sujeitas às regras de cada\n          campanha vigente.\n          "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n            Consulte o regulamento")]), _vm._v(".\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Taxa de Recarga"), _c('sup', [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-plan"
  }, [_vm._v("Código do Vendedor:")]), _vm._v(" "), _c('p', {
    staticClass: "label-first-charge"
  }, [_vm._v("\n              (Opcional) Informe o código se possuir\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "onoffswitch-label",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": "round-switch"
    }
  }, [_c('span', {
    staticClass: "onoffswitch-inner"
  }), _vm._v(" "), _c('span', {
    staticClass: "onoffswitch-switch"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          ¹ ² As condições promocionais estão sujeitas às regras de cada\n          campanha vigente.\n          "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n            Consulte o regulamento")]), _vm._v(".\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-5dc1d5a0!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/adhesion/choose-plan.vue
// module id = 2143
// module chunks = 1